module.exports = __webpack_public_path__ + "img/logo3.b4c95001.png";